export const seoConfig = {
  "/": {
    lang: "en",
    title: "AI-Powered Listing Generator",
    focusKeyphrase: "AI listing generator for collectors",
    description:
      "Upload photos of your stamps, coins, and collectibles. Our AI writes product descriptions and drafts eBay or WooCommerce listings in seconds.",
    keywords: "AI listing generator, stamps, collectibles, eBay listings, WooCommerce",
    canonical: "/",
    noIndex: false,
  },

  "/image-upload": {
    lang: "en",
    title: "Image Upload",
    noIndex: true
  },

  "/dashboard" : {
    lang: "en",
    title: "Dashboard Page",
    noIndex: true
  },

  "/client-profile" : {
    lang: "en",
    title: "Client Profile",
    noIndex: true
  },

  "/api-management" : {
    lang: "en",
    title: "Api Management",
    noIndex: true
  },

  "/settings" : {
    lang: "en",
    title: "Settings Page",
    noIndex: true
  },

  "/terms-of-service": {
    lang: "en",
    title: "Terms of Service",
    description: "Read our Terms of Service before using the platform.",
    noIndex: false
  },

  "/privacy-policy": {
    lang: "en",
    title: "Privacy Policy",
    description: "Learn how we collect and protect your personal data.",
    noIndex: false
  },

  "/legal-notice": {
    lang: "en",
    title: "Legal Notice",
    description: "Legal information about our platform.",
    noIndex: false
  },

  "/image-processing": {
    lang: "en",
    title: "Image Processing",
    noIndex: true
  },

  "/bug-reports": {
    lang: "en",
    title: "Bug Reports",
    noIndex: true
  },

  "/workflow-management": {
    lang: "en",
    title: "Workflow Management",
    noIndex: true
  },

  "/workflow-editor": {
    lang: "en",
    title: "Workflow Editor",
    noIndex: true
  },
};

export const defaultSeo = {
  lang: "en",
  title: "",
  description: "AI-powered listing generator for collectibles.",
  keywords: "collectibles, AI, listings",
  noIndex: false,
};